export default "__VITE_ASSET__d10bbbbb__"